<template>
  <div class="index">
    <el-alert v-if="retrieve.results.length == 0" title="暂无数据" type="success" :closable="false"></el-alert>
    <div
      class="item"
      v-for="(item, index) in retrieve.results"
      :key="index"
      @click="click(item.id)"
    >
      <div class="image">
        <img :src="util.getImageUrl(util.getHead(util.string2Array(item.image)), '300x300')" alt />
      </div>
      <div class="content">
        <div class="name">{{item.name}}</div>
        <div class="features">{{item.description}}</div>
      </div>
    </div>

    <div class="divider"></div>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "MarketingPage",
  computed: {
    retrieve() {
      return this.$store.state.marketing.commodityMarketing.retrieve;
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit("change", e);
    },
    click(id) {
      window.open(`/service/detail/${id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  .divider {
    height: 1px;
    background: #f4f4f4;
  }
  .item {
    height: 300px;
    padding: 20px 0;
    border-top: 1px solid #f4f4f4;
    cursor: pointer;

    .image {
      display: inline-block;
      width: 300px;
    }

    .content {
      display: inline-block;
      width: 780px;

      vertical-align: top;

      padding-left: 20px;
    }

    img {
      border-radius: 10px;
      //   box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
      width: 300px;
      height: 300px;
    }

    .name {
      height: 40px;
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }

    .features {
      line-height: 20px;
      color: #6d7278;
    }
  }

  .page {
    .prev,
    .next {
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }

    .num {
      border: 1px solid #ccc;
      display: inline-block;
      margin: 0 5px;
      padding: 0 5px;
      cursor: pointer;
    }
    .active {
      color: red;
    }
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

